/** The six buckets Dealroom's investor types are mapped into, as a person reads them. */
export const INVESTOR_TYPE_LABELS = {
    vc: 'VC',
    family_office: 'Family office',
    corporate: 'Corporate',
    angel: 'Angel',
    accelerator: 'Accelerator',
    other: 'Other',
};
const LABEL_BY_TYPE = new Map(Object.entries(INVESTOR_TYPE_LABELS));
/**
 * A candidate carries whatever Dealroom called it, which is a wider vocabulary
 * than our six: an unmapped term is shown as it came rather than as "other".
 */
export function investorTypeLabel(type) {
    if (type === null)
        return '';
    return LABEL_BY_TYPE.get(type) ?? type;
}
//# sourceMappingURL=investorType.js.map